/**
 * Limites da agenda que vêm do back (login e GET /api/auth/me).
 *
 * maxGruposLote — profissionais por agendamento em lote (AGENDA_MAX_GRUPOS_LOTE no .env do back; padrão 4).
 * Docs: 4clinics_backend/docs/plano-lote-varios-profissionais.md.
 */

const PADRAO_MAX_GRUPOS_LOTE = 4

let maxGrupos = null

/** Define o limite (vem do back). Valor vazio ou inválido volta ao padrão. */
export const definirMaxGruposLote = (valor) => {
  const n = Number(valor)
  maxGrupos = Number.isInteger(n) && n > 0 ? n : null
}

export const maxGruposLote = () => maxGrupos || PADRAO_MAX_GRUPOS_LOTE

/**
 * passoAgendaMin — passo da agenda em minutos (parâmetro MV_AGENDAMIN, por empresa/filial; padrão 5): o início do atendimento só aceita
 * múltiplos dele e os horários sugeridos andam por ele. Docs: 4clinics_backend/docs/plano-agenda-horas-quebradas.md.
 */
export const PASSO_AGENDA_PADRAO_MIN = 5

let passoAgenda = null

/** Define o passo (vem do back). Vazio ou inválido (não divide a hora) volta ao padrão. */
export const definirPassoAgendaMin = (valor) => {
  const n = Number(valor)
  passoAgenda = Number.isInteger(n) && n >= 1 && n <= 60 && 60 % n === 0 ? n : null
}

export const passoAgendaMin = () => passoAgenda || PASSO_AGENDA_PADRAO_MIN

/**
 * tussObrigatorio — parâmetro MV_TUSSOBRIG (por empresa/filial; padrão: sim): tabela de preços de plano de saúde exige tabela e código TUSS nos itens
 * ativos. Com "não" eles podem faltar; a fatura sempre exige. Docs: 4clinics_backend/docs/plano-tuss.md §10.
 */
let tussExigido = true

export const definirTussObrigatorio = (valor) => {
  tussExigido = valor !== false
}

export const tussObrigatorio = () => tussExigido

/**
 * sessoesMaximo — parâmetro MV_SESSMAXAT (por empresa/filial; padrão 2): o maior valor que o campo "Sessões por atendimento" do pacote aceita.
 * O teto técnico é 10 (travas do banco). Docs: 4clinics_backend/docs/plano-sessoes-por-atendimento.md.
 */
export const SESSOES_MAXIMO_PADRAO = 2
export const SESSOES_TETO = 10

let sessoesMax = null

/** Define o máximo (vem do back). Vazio ou fora de 1..10 volta ao padrão. */
export const definirSessoesMaximo = (valor) => {
  const n = Number(valor)
  sessoesMax = Number.isInteger(n) && n >= 1 && n <= SESSOES_TETO ? n : null
}

export const sessoesMaximo = () => sessoesMax || SESSOES_MAXIMO_PADRAO
